import { useContext } from "react";
import { useLocation, matchPath, Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

import Search from "./search";

import bell from "../../assets/bell.png";

import { FiltersContext } from "../../services/context/filters";
import { W3Context } from "../../services/context";

import { formattedWallet } from "../../utils/account";
import PATHS from "../../utils/paths";

import "./auctionNavigationStyles.css";

const AuctionNavigation = ({
  onClickConnectWallet,
  showPriceFilter = true,
  showTimeFilter = true,
}) => {
  const location = useLocation();
  const { pathname } = location;
  let match;
  // https://stackoverflow.com/a/59217492
  // eslint-disable-next-line no-unused-vars
  for (let [_, value] of Object.entries(PATHS)) {
    match = matchPath(pathname, {
      path: value,
      exact: true,
      strict: false,
    });

    if (match) {
      break;
    }
  }

  const { setFilters } = useContext(FiltersContext);
  const { active, account /*library*/ } = useContext(W3Context);

  const onClickNavigationButton = () => {
    setFilters({});
  };

  return (
    <Container className="auction-navigation mw-100">
      <Row className="d-flex align-items-center justify-content-center searching-row">
        <Col xs={12} lg={6} className="text-center mx-auto">
          {match && match.path !== PATHS.AUCTIONS_ID && (
            <Search
              showPriceFilter={showPriceFilter}
              showTimeFilter={showTimeFilter}
            />
          )}
        </Col>
        <Col className="d-none d-lg-flex justify-content-end align-items-center">
          {match && match.path !== PATHS.AUCTIONS && (
            <Link
              to={{
                pathname: PATHS.AUCTIONS,
              }}
            >
              <button
                className="purple-button"
                onClick={onClickNavigationButton}
                disabled={!active}
              >
                CURRENT AUCTIONS
              </button>
            </Link>
          )}
          {match &&
            match.path !== PATHS.AUCTIONS_ID &&
            match.path !== PATHS.AUCTIONS_MYAUCTIONS && (
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYAUCTIONS,
                }}
              >
                <button
                  className="purple-button"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  START NEW AUCTION
                </button>
              </Link>
            )}
          {match &&
            match.path !== PATHS.AUCTIONS_ID &&
            match.path !== PATHS.AUCTIONS_MYAUCTIONS && (
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYAUCTIONS,
                }}
              >
                <button
                  className="purple-button"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  MY AUCTIONS
                </button>
              </Link>
            )}
          {match &&
            match.path !== PATHS.AUCTIONS_ID &&
            match.path !== PATHS.AUCTIONS_MYBIDS && (
              <Link
                to={{
                  pathname: PATHS.AUCTIONS_MYBIDS,
                }}
              >
                <button
                  className="purple-button"
                  onClick={onClickNavigationButton}
                  disabled={!active}
                >
                  MY BIDS
                </button>
              </Link>
            )}
          {active ? (
            <span className="blue-button">{formattedWallet(account)}</span>
          ) : (
            <button
              onClick={() => onClickConnectWallet()}
              className="purple-button"
            >
              <span>Connect Wallet</span>
            </button>
          )}
        </Col>
        {/* <Col xs={2} lg={1} className="px-0">
          <button
            className="notification-button orange-button rounded bell-button"
            disabled={!active}
          >
            <div>3</div>
            <img src={bell} alt="bell" />
          </button>
        </Col> */}
      </Row>
    </Container>
  );
};

export default AuctionNavigation;
